<template>
  <div class="inspectorrating">
    <v-layout row wrap class="inspectorrating--title">
      <v-flex xs12>
        <h2>
          Your Rating for {{inspector.givenName}} {{inspector.familyName}}
          <small>{{inspector.company}}</small>
        </h2>
      </v-flex>
    </v-layout>

    <v-layout
v-if="rating.rating"
row
wrap
class="inspectorrating--row inspectorrating--value-rating">
      <v-flex xs12 sm4>
        <label>Rating</label>
      </v-flex>
      <v-flex xs12 sm8>
        <v-rating
          :dense="$vuetify.breakpoint.smAndDown"
          :value="rating.rating"
          length="10"
          readonly />
      </v-flex>
    </v-layout>

    <v-layout
v-if="rating.comment"
row
wrap
class="inspectorrating--row inspectorrating--value-comment">
      <v-flex xs12 sm4>
        <label>Comment</label>
      </v-flex>
      <v-flex xs12 sm8 class="inspectorrating--comment">
        <span v-html="rating.comment"></span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    inspector: {
      type: Object,
      required: true,
    },
    rating: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

h2 {
  border-bottom: 1px solid lighten($theme-color-gray, 49.02);
  font-size: 1.5rem;
  font-weight: $typography-weight-bold;
  margin: 0 0 20px;
  padding: 0 0 20px;
  text-align: center;

  small {
    display: block;
    font-size: 1.25rem;
    font-weight: $typography-weight-semibold;
  }
}

.inspectorrating {
  &--comment {
    font-size: 1rem;

    ::v-deep h1,
    ::v-deep h2,
    ::v-deep h3,
    ::v-deep h4,
    ::v-deep h5,
    ::v-deep h6 {
      font-weight: $typography-weight-bold;
      margin: 0.6em 0;
    }

    ::v-deep h1 {
      font-size: 2.25rem;
      line-height: 1.2;
    }

    ::v-deep h2 {
      font-size: 2rem;
      line-height: 1.2;
    }

    ::v-deep h3 {
      font-size: 1.75rem;
      line-height: 1.24;
    }

    ::v-deep h4 {
      font-size: 1.5rem;
      line-height: 1.23;
    }

    ::v-deep h5,
    ::v-deep h6 {
      font-size: 1.25rem;
    }
  }

  &--row {
    padding-bottom: 10px;
    padding-top: 10px;
  }
}
</style>
